import CustomLayout from 'component/layout/custom_layout';

interface IProps {
    children: React.ReactNode;
    screenTitle: string;
}

function MyStylesItemsLayout({ children, screenTitle }: IProps) {
    return (
        <CustomLayout title={screenTitle} showHeaderFilter={false}>
            <div
                id="order"
                style={{
                    height: `100%`,
                    overflowY: 'scroll',
                }}
            >
                {children}
            </div>
        </CustomLayout>
    );
}

export default MyStylesItemsLayout;
